var map = {
	"./admin.ts": 96,
	"./attach.ts": 139,
	"./config.ts": 112,
	"./dashboard.ts": 472,
	"./declare.ts": 140,
	"./edu.ts": 72,
	"./edumain.ts": 110,
	"./exam.ts": 28,
	"./form.ts": 173,
	"./license.ts": 162,
	"./log.ts": 200,
	"./login.ts": 87,
	"./phishing.ts": 115,
	"./quiz.ts": 188,
	"./register.ts": 183,
	"./share.ts": 186,
	"./startExam.ts": 97,
	"./tag.ts": 117,
	"./target.ts": 68,
	"./template.ts": 76,
	"./user.ts": 67
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1246;